import React, { useEffect, useState } from "react";
import "../PositionCodes.css";
import { useNavigate } from "react-router-dom";
import { useRegistrationContext } from "../../../contexts/ClientRegistrationContext";

const ChooseDefaultPosCodes = () => {
  const { data, updateData } = useRegistrationContext();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const [posCodeType, setPosCodeType] = useState("");

  useEffect(() => {
    const fetchPosCodeType = async () => {
      try {
        if (data.selectedPosCodeType !== undefined) {
          setPosCodeType(data.selectedPosCodeType);
        }
      } catch (err: any) {
        console.log("Failed to fetch pos code type", err);
      }
    };

    fetchPosCodeType();
  }, [updateData, data.selectedPosCodeType]);

  // Redirect to registration if data not there
  useEffect(() => {
    if (!data.userAgreement) {
      navigate("/registration");
    }
  }, [data.userAgreement, navigate]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const handleNavigateToPositionCodes = async () => {
    if (await validateFields()) {
      navigate("/client/registration/position-codes", {
        state: { selectedPosCodeType: posCodeType },
      });
      window.scrollTo(0, 0);
    }
  };

  const validateFields = () => {
    if (!posCodeType) {
      setErrorMessage("Please select a position code type before continuing.");
      return false;
    }
    return true;
  };

  return (
    <div className="content-container">
      <div className="header-container">
        <h1>Step 3: Position Codes</h1>
      </div>
      <div className="divider"></div>
      <div className="data-container">
        <div className="text-body">
          You now have the ability to define in advance the background check
          services Oxford Document Management will perform based on the position
          of a potential employee or volunteer ("Position Codes"). This unique
          feature streamlines the screening process while ensuring consistency
          and compliance. Predefined Position Codes allow for online completion
          of the required Authorization Form(s) and help maintain compliance
          with key <b>Fair Credit Reporting Act (FCRA)</b> requirements.
          Additionally, this approach promotes standardized, nondiscriminatory
          screening practices across all candidates.
        </div>

        <div>
          {" "}
          <a
            href="https://www.consumerfinance.gov/learnmore/."
            target="_blank"
            rel="noopener noreferrer"
          >
            LEARN MORE ABOUT COMPLYING WITH THE FCRA
          </a>
        </div>

        <div className="text-body">
          For your convenience, examples of default Position Codes commonly used
          by our clients in faith-based organizations are detailed below. You
          may choose to use these defaults or modify them to fit your needs.
          {/* <a
            href="https://oxfordstoreacctdev.blob.core.windows.net/documents/Public-Records-Check-Fee-Schedule.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            here.
          </a> */}{" "}
          Position Codes can be updated at any time to accommodate changes in
          your screening requirements. If you have any questions or need further
          clarification, please call us at (800) 801-9114 or email us at{" "}
          <a href="mailto:request@oxforddoc.com">request@oxforddoc.com</a>.
        </div>
        <div className="text-body" style={{ flex: "0 0 100%" }}>
          <b>
            Choose a default to start with, or choose to start defining position
            codes from scratch.
          </b>
        </div>
        <br></br>

        <label className="radio-button">
          <input
            type="radio"
            value="general"
            name="posCodeType"
            checked={posCodeType === "general"}
            onChange={() => setPosCodeType("general")}
          />
          General Default Position Codes
        </label>

        <label className="radio-button">
          <input
            type="radio"
            value="ucc"
            name="posCodeType"
            checked={posCodeType === "ucc"}
            onChange={() => setPosCodeType("ucc")}
          />
          <span>UCC Default Position Codes</span>
        </label>

        {/* <label className="radio-button">
          <input
            type="radio"
            value="uua"
            name="posCodeType"
            checked={posCodeType === "uua"}
            onChange={() => setPosCodeType("uua")}
          />
          <span>UUA Default Position Codes</span>
        </label> */}

        <label className="radio-button">
          <input
            type="radio"
            value="scratch"
            name="posCodeType"
            checked={posCodeType === "scratch"}
            onChange={() => setPosCodeType("scratch")}
          />
          <span>Create Your Own</span>
        </label>
        {errorMessage && (
          <div className="error-message" style={{ color: "red" }}>
            {errorMessage}
          </div>
        )}
      </div>
      <div className="btn-center">
        <button
          className="oxbtn btn-green"
          onClick={handleNavigateToPositionCodes}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default ChooseDefaultPosCodes;
